import { z } from 'zod';

export const consentRecordSchema = z.object({
  purpose: z.enum(['non_essential_cookies', 'marketing_email', 'analytics']),
  granted: z.boolean(),
  policyVersion: z.string().min(1),
});
export type ConsentRecordInput = z.infer<typeof consentRecordSchema>;

export const requestAccountDeletionSchema = z.object({
  confirmEmail: z.string().email(),
});
export type RequestAccountDeletionInput = z.infer<typeof requestAccountDeletionSchema>;

export const contactFormSchema = z.object({
  name: z.string().min(1).max(160),
  email: z.string().email(),
  message: z.string().min(1).max(4000),
  honeypot: z.string().max(0).optional(), // must stay empty; spam bots fill it in
});
export type ContactFormInput = z.infer<typeof contactFormSchema>;
